import { useState } from "react"
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import type { Message, MessageProps } from "~/shared/ui/kit"

/**
 * Используется вместе с {@link Message}.
 * @hook
 * @category Hook
 */
export function useMessage() {
	const [message, setMessage] = useState("")
	const [messageType, setMessageType] = useState<MessageProps["type"]>("success")

	const setMessageAndType = (message: string, messageType: MessageProps["type"] = "success") => {
		setMessageType(messageType)
		setMessage(message)
	}

	const reset = () => setMessage("")

	return [message, messageType, setMessageAndType, reset] as const
}